/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import { useRouteMatch } from "react-router"
import Grid from "../../../components/Grid/Grid"
import SelectItem from "../../../components/Grid/SelectItem"
import Loader from "../../../components/Loader/Loader"
import Pagination from "../../../components/Pagination/Pagination"
import { iAsset, iAssetQuery } from "../../../definitions/Assets"
import { iUrlParams } from "../../../definitions/interfaces"
import { useData } from "../../../hooks/useData"
import AssetFilters from "../../Assets/Filters"
import AssetItem from "../../Assets/Item"

interface iProps {
  onChange?: (...event: any[]) => void
  value?: any
}

const ManageAssets: FunctionComponent<iProps> = ({ onChange }) => {
  const match = useRouteMatch<iUrlParams>()

  const { data } = useData<iAssetQuery, iAsset>({
    link: "/v2/exhibitions/" + match.params.url + "/assets",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const [selected, setSelected] = useState<iAsset[]>(data)
  const _selected = useRef<iAsset[]>(data)

  useEffect(() => {
    setSelected(data)
    _selected.current = data
  }, [data])

  const { data: assets, loading, total, setQuery, query } = useData<
    iAssetQuery,
    iAsset
  >({
    link: "/v2/assets",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const handleClick = useCallback(
    (asset: iAsset) => {
      if (_selected.current.find((a) => a._id === asset._id)) {
        _selected.current = _selected.current.filter((a) => a._id !== asset._id)
      } else {
        _selected.current = [..._selected.current, asset]
      }

      setSelected(_selected.current)
      onChange && onChange(_selected.current.map((ap) => ap._id))
    },
    [setSelected],
  )

  const handleRemove = useCallback(
    (asset: iAsset) => {
      const tmp = _selected.current.filter((a) => a._id !== asset._id)
      _selected.current = tmp
      setSelected(tmp)
      onChange && onChange(tmp.map((asset) => asset._id))
    },
    [setSelected],
  )

  return (
    <>
      <div className="content-header">
        <AssetFilters query={query} setQuery={setQuery} />
      </div>
      <div className="flex-grids">
        <div className="col-6 grid-wrap">
          <label>Select assets</label>
          {loading ? (
            <Loader />
          ) : (
            <Grid>
              {assets.map((asset) => (
                <SelectItem<iAsset>
                  key={asset._id}
                  item={asset}
                  isSelected={!!selected.find(({ _id }) => _id === asset._id)}
                  onClick={handleClick}
                >
                  <AssetItem {...asset} />
                </SelectItem>
              ))}
            </Grid>
          )}
        </div>
        <div className="grid-separator"></div>
        <div className="col-6 grid-wrap selected-wrap">
          <label>Selected assets</label>
          <Grid>
            {selected.map((asset = {} as iAsset) => (
              <SelectItem<iAsset>
                key={asset._id}
                item={asset}
                isSelected={false}
                onClick={handleRemove}
              >
                <AssetItem {...asset} />
              </SelectItem>
            ))}
          </Grid>
        </div>
      </div>
      <Pagination total={total} setQuery={setQuery} limit={50} />
    </>
  )
}

export default ManageAssets
